var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.91658L7.7 0L7.055 0.759682L9.355 2.67627L10 1.91658ZM2.94 0.759682L2.3 0L0 1.91162L0.645 2.6713L2.94 0.759682ZM5.25 3.04866H4.5V6.02781L6.875 7.4429L7.25 6.83218L5.25 5.65541V3.04866ZM5 1.06256C2.515 1.06256 0.5 3.06355 0.5 5.53128C0.5 7.99901 2.51 10 5 10C7.485 10 9.5 7.99901 9.5 5.53128C9.5 3.06355 7.485 1.06256 5 1.06256ZM5 9.00695C3.065 9.00695 1.5 7.45283 1.5 5.53128C1.5 3.60973 3.065 2.05561 5 2.05561C6.935 2.05561 8.5 3.60973 8.5 5.53128C8.5 7.45283 6.935 9.00695 5 9.00695Z",
    fill: "#004433"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9e3da1bf79e41b2e7a43c00d2acac655.svg";
export { ForwardRef as ReactComponent };